import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ImportantPersonActions = createActionGroup({
  source: 'Important Person',
  events: {},
});
